/**
 * /students/:personId means something different depending on who is asking.
 *
 * An administrator gets the full student record; a parent gets their child's
 * page — missing work, grades, attendance. The server decides what either may
 * actually see, so this only chooses the shape of the page.
 */
import { useOutletContext } from 'react-router-dom';
import type { AppLayoutContext } from '~/types';
import { roleGroupFor } from '~/components/Sidebar/sidebarLayout';
import StudentDetail from './StudentDetail';
import ParentStudentPage from '../ParentStudent/ParentStudentPage';

export default function StudentRoute() {
  const { roleContext } = useOutletContext<AppLayoutContext>();

  return roleGroupFor(roleContext?.selectedRole) === 'family'
    ? <ParentStudentPage />
    : <StudentDetail />;
}
